class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.header = document.querySelector("#main_header");
    this.full_navigation = document.querySelector(
      "#shopify-section-full-navigation",
    );

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector("#predictive-search");
    this.closeSearch = this.querySelector(".closeSearch");

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
        body.classList.add("showSearch");

        document.querySelector(".search-overlay").top =
          this.header.clientHeight + this.full_navigation.clientHeight + "px";
      }, 200).bind(this),
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(
      Shopify.routes.root +
        `search/suggest?q=${searchTerm}&resources[limit]=4&resources[limit_scope]=each&section_id=predictive-search`,
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        body.classList.add("showSearch");
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = "block";
    body.classList.add("showSearch");
  }

  close() {
    this.predictiveSearchResults.style.display = "none";
    body.classList.remove("showSearch");
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("predictive-search", PredictiveSearch);
